// extracted by mini-css-extract-plugin
export default {"cover":"ProductItem_cover__xFImW","popover":"ProductItem_popover__E6OC4"};